import React, {useState , useEffect} from 'react';
import './Heading.css';


function Heading() {
  const [toggleMenu, setToggleMenu] = useState(false)
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)

  const toggleNav = () => {
    setToggleMenu(!toggleMenu)
  }

  useEffect(() => {
    const changeWidth = () => {
      setScreenWidth(window.innerWidth);
    }
  
    window.addEventListener('resize' , changeWidth)

  }, [])

  const liTage = () => {
    setToggleMenu(!toggleMenu)
  }
  

  return (
    <div className='head'>
      <a className='logo' href="#">Hakeem<span>.dev</span></a>
      <nav>
        {(toggleMenu || screenWidth > 800 ) && (
          <ul className='ul'>
            <li onClick={liTage}><a href='#'>Home</a></li>
            <li onClick={liTage}><a href='#tools'>Tools</a></li>
            <li onClick={liTage}><a href='#process'>Process</a></li>
            <li onClick={liTage}><a href='#work'>Work</a></li>
            <li onClick={liTage}><a href='#contact'>Contact</a></li>
          </ul>
        )}
        
        <div class="menu" onClick={toggleNav}>
          <span class="bar"></span>
          <span class="bar"></span>
          <span class="bar"></span>
        </div>
      </nav>
    </div>
  )
}

export default Heading

